module.exports = __webpack_public_path__ + "static/media/servicio.3c0938a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/aeropost/servicio.png
// module id = 1205
// module chunks = 0